// import ReserveFood from './ReserveFood';

export default {
  // component: ReserveFood,
  component: load(() => import(/* webpackChunkName: "Feed-Report-ReserveFood" */ './ReserveFood')),
  permissions: ['FeedingConsoleMenu/FeedingConsoleReport/ReportOrderMenu'],
  name: app.translate('آمار رزرو غذا'),
  icon: 'clipboard-check',
  drawer: true,
};
